<app-dialog [config]="data.config" (actionButtonClicked)="onFormSubmit($event)">
    <ng-container dialog-title>
        New User
    </ng-container>

    <ng-container dialog-process-in-progress>
        <app-form
            [form]="addUserToClientForm?.form"
            [observable]="addUserToClientForm?.controlsObservable"
            [hiddenActions]="true"
        ></app-form>
    </ng-container>
</app-dialog>
